module.exports = __webpack_public_path__ + "img/ic-arrow-s-inactive.cc4ac9b7.svg";